export default [
    {
        path: '/notifications',
        name: 'Notifications',
        component: () => import('@/views/Notifications/NotificationsList.vue')
    }
]
